import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  text: 'Lavoro in ambito pediatrico e ogni bambino richiede materiale diverso. Da quando uso il sistema apro la libreria di attività, scelgo per obiettivo e livello di difficoltà e preparo la seduta in dieci minuti. Le schede di osservazione mi hanno semplificato moltissimo anche i colloqui con i genitori.',
  author: 'Giulia Moretti',
  role: 'Terapista Occupazionale in ambito pediatrico, 34 anni',
  location: 'Milano'
}, {
  text: 'In reparto di neuroriabilitazione il tempo per la documentazione non basta mai. I report clinici e le schede di rivalutazione sono diventati la mia base di lavoro: li personalizzo per ogni paziente e riesco a chiudere le relazioni senza portarmi il lavoro a casa la sera.',
  author: 'Francesca Rinaldi',
  role: 'Terapista Occupazionale neurologica, 41 anni',
  location: 'Roma'
}, {
  text: 'Con i pazienti anziani lavoro soprattutto su autonomia e adattamenti domestici. Il kit su ausili, ergonomia e conservazione dell’energia mi ha dato protocolli chiari da proporre anche ai caregiver, e la qualità percepita del mio intervento è cresciuta subito.',
  author: 'Elisa Bertani',
  role: 'Terapista Occupazionale in ambito geriatrico, 47 anni',
  location: 'Torino'
}, {
  text: 'Ho uno studio privato e avevo bisogno di trasmettere ordine e professionalità. Le valutazioni iniziali, i programmi terapeutici e i materiali stampabili mi permettono di presentare un percorso strutturato fin dal primo incontro, e i pazienti se ne accorgono.',
  author: 'Martina Colombo',
  role: 'Terapista Occupazionale libera professionista, 38 anni',
  location: 'Bologna'
}, {
  text: 'Faccio assistenza domiciliare e ogni casa è un contesto diverso. I programmi sulle attività della vita quotidiana e le strategie compensative mi danno una struttura affidabile da adattare al volo, senza dover ricostruire tutto il materiale prima di ogni visita.',
  author: 'Chiara D’Amico',
  role: 'Terapista Occupazionale domiciliare, 29 anni',
  location: 'Napoli'
}];
export function Testimonials() {
  return <section className="border-y border-brand-line bg-brand-cloud px-4 py-5" data-id="element-168" data-mp="1sh3918rilm2f">
      <div className="mx-auto max-w-4xl" data-id="element-169" data-mp="1ofhod18qo3ho">
        <div className="mb-3 text-center" data-id="element-170" data-mp="1jihppbe7y30l">
          <h2 className="mb-1 font-display text-xl font-extrabold uppercase sm:text-3xl" data-id="element-171" data-mp="1jhpvo509sdcf">
            COSA DICONO I COLLEGHI
          </h2>
          <p className="font-display text-xs font-bold uppercase tracking-wide text-brand-navy sm:text-sm" data-id="element-172" data-mp="19sermws8pyve">
            Recensioni verificate da Terapisti Occupazionali
          </p>
        </div>
        <div className="space-y-2.5" data-id="element-173" data-mp="10rqbnwjadofv">
          {testimonials.map(testimonial => <article key={testimonial.author} className="rounded-xl border border-brand-line bg-white p-3 shadow-sm sm:p-4" data-id="element-174" data-mp="10px2oal7as4p">
              <div className="mb-1.5 flex gap-1" aria-label="Valutazione 5 stelle" data-id="element-175" data-mp="qtu41epk5bmi">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-4 w-4 fill-brand-gold text-brand-gold" data-id="element-176" data-mp="32g4bndc12uqd" />)}
              </div>
              <p className="mb-2.5 text-sm font-medium italic leading-snug text-brand-slate sm:text-base" data-id="element-177" data-mp="37i3d2ho7jhko">
                “{testimonial.text}”
              </p>
              <div className="flex items-center gap-2.5 border-t border-brand-line pt-2.5" data-id="element-178" data-mp="3gfneprpzffvt">
                <div className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-sage font-display text-base font-extrabold text-brand-navy" data-id="element-179" data-mp="2jrh7cx1oe9du">
                  {testimonial.author.charAt(0)}
                </div>
                <div className="leading-tight" data-id="element-180" data-mp="2spt65mcp4dhd">
                  <p className="font-display text-sm font-bold text-brand-ink" data-id="element-181" data-mp="2xicjci7h16ln">{testimonial.author}</p>
                  <p className="text-[11px] font-semibold uppercase tracking-wide text-brand-slate" data-id="element-182" data-mp="210gbihvuqtyi">
                    {testimonial.role} — {testimonial.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}